import { useMemo } from 'react';

import { CarouselReward } from 'components/rewards-carousel/types';
import { useLoyaltyRewardsList } from 'hooks/use-loyalty-rewards-list';

import { IUseCarouseRewardsParams } from '../types';

const useCarouseRewards = ({ rewards }: IUseCarouseRewardsParams) => {
  const { engineRewardsMap } = useLoyaltyRewardsList();

  const carouselRewards = useMemo(() => {
    if (!rewards) {
      return [];
    }
    return rewards.reduce((acc: CarouselReward[], reward) => {
      const engineReward = engineRewardsMap[reward?.loyaltyEngineId || ''];
      if (reward && engineReward) {
        acc.push({
          ...reward,
          locked: engineReward.locked || false,
          pointCost: engineReward.pointCost,
          rewardBenefitId: engineReward.rewardBenefitId,
        });
      }
      return acc;
    }, []);
  }, [rewards, engineRewardsMap]);

  return carouselRewards;
};

export default useCarouseRewards;
